import { useContext, useMemo } from "react";

import EastOutlined from "@mui/icons-material/EastOutlined";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { AppContext } from "App";
import { MemberManagementIcon } from "components/Icons/Icons";
import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";
import { USER_ROLE_ADMIN } from "core/useSession";

export const MEMBER_ACTION_MANAGE_ACCOUNT = "manage_account";

export default function MemberDataTable({
  members,

  onItemAction,

  itemSelectLabel,
  onItemSelect,
  isLoading,
  pageSizes = [5, 10, 25, 50, 100],
  defaultPageSize = 5,
  rowHeight = 80,
}) {
  const { globalState } = useContext(AppContext);

  const COLUMNS_MEMBERS = useMemo(
    () => [
      { field: "last_name", headerName: "Last", flex: 1 },
      { field: "first_name", headerName: "First", flex: 1 },
      { field: "middle_name", headerName: "Middle", flex: 0.5 },
      { field: "business_name", headerName: "Business", flex: 2 },
      { field: "city", headerName: "City", flex: 1 },
      { field: "state_abbreviation", headerName: "State", flex: 0.5 },
      { field: "phone", headerName: "Phone #", flex: 0.5 },

      ...(onItemAction && globalState?.user_role === USER_ROLE_ADMIN
        ? [
            {
              field: "id",
              headerName: "Manage",
              type: "actions",
              flex: 0.5,
              sortable: false,
              getActions: (params) => {
                const producer = members?.find((m) => m.id === params.row?.id);
                return [
                  <GridActionsCellItem
                    key="manage"
                    label="Manage"
                    disabled={!producer}
                    onClick={() => {
                      if (producer) {
                        onItemAction(producer, MEMBER_ACTION_MANAGE_ACCOUNT);
                      }
                    }}
                    icon={<MemberManagementIcon />}
                  />,
                ];
              },
            },
          ]
        : []),

      {
        field: "producer_token",
        headerName: itemSelectLabel || "View Account",
        type: "actions",
        flex: 0.5,
        sortable: false,
        getActions: (params) => {
          const producer = members?.find((m) => m.producer_token === params.row?.producer_token);
          return [
            <GridActionsCellItem
              key="edit"
              label="View Account"
              disabled={!producer?.producer_token}
              onClick={() => {
                if (producer?.producer_token) {
                  onItemSelect?.(producer);
                }
              }}
              icon={<EastOutlined />}
            />,
          ];
        },
      },
    ],
    [members, onItemAction, globalState, onItemSelect, itemSelectLabel]
  );

  return (
    <TilleyDataGrid
      rows={members || []}
      columns={COLUMNS_MEMBERS}
      pageSizeOptions={pageSizes}
      defaultPageSize={defaultPageSize}
      gridKey="members-data"
      getRowId={(row) => row.id}
      rowHeight={rowHeight}
      isLoading={isLoading}
      sx={{ maxWidth: "99%", boxSizing: "border-box" }}
    />
  );
}
